import { getToken, removeToken, setToken } from "@/utils/token";
import md5 from "md5";
import axios from "axios";
import { Message, MessageBox } from "element-ui";
import {
  CONST_DEFAULT_REQUEST_HEADER,
  CONST_NONE_APPEND_WORD,
  CONST_VD_APPID,
  TOKEN_AND_SIGNATURE_ERROR_GROUP
} from "@/config/constant";

function toLoginPage() {
  let routerPath =
    location.pathname === "/rwa/joint-login" ? "/rwa/joint-login" : "/login";
  const href = location.href;
  const [_, query] = href.split("?");
  if (query) {
    routerPath += `?${query}`;
  }
  window.location.href = routerPath;
}

class httpRequest {
  constructor() {
    this.options = {
      method: "POST",
      url: "/m.api"
    };
    this.queue = {};
    this.data = {};
    this.SecurityType = {
      UserLogin: {
        name: "UserLogin",
        code: 0x2000
      },
      RegisteredDevice: {
        name: "RegisteredDevice",
        code: 0x0100
      },
      None: {
        name: "None",
        code: 0
      }
    };
    this.api = {};
    this.aid = CONST_VD_APPID;
    this.serverTime = "";
    this.isLoginInvalid = false;
  }

  // 销毁请求实例
  destroy(url) {
    delete this.queue[url];
    const queue = Object.keys(this.queue);
    return queue.length;
  }

  // 请求拦截
  interceptors(instance) {
    const that = this;
    // 添加请求拦截器
    instance.interceptors.request.use(
      config => {
        if (that.options.method == "POST") {
          config.headers["Content-Type"] =
            "application/x-www-form-urlencoded;charset=UTF-8";
        }
        return config;
      },
      error => {
        // 对请求错误做些什么
        return Promise.reject(error);
      }
    );

    // 添加响应拦截器
    instance.interceptors.response.use(
      res => {
        const { data } = res;
        if (data && data.stat) {
          that.serverTime = data.stat.systime;
        }
        if (that.access(data)) {
          // 处理请求返回数据
          that.afterRequest(this.api.METHOD_NAME, data.content[0]);
          return data.content[0];
        } else {
          if (data.stat.stateList.length == 0) {
            // 系统错误
            const { msg, code } = data.stat;
            if (
              !this.isLoginInvalid &&
              TOKEN_AND_SIGNATURE_ERROR_GROUP.indexOf(code) > -1
            ) {
              this.isLoginInvalid = true;
              MessageBox.confirm("登录过期,返回登录页?", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                type: "error",
                center: true
              }).then(() => {
                removeToken();
                MessageBox.close();
                toLoginPage();
                this.isLoginInvalid = false;
              });
              return;
            }
            return Promise.reject(data.stat.code);
          } else {
            // 业务错误
            const { msg, code } = data.stat.stateList[0];

            let returnMsg = "";
            // 展示提示信息
            if (that.api.ERROR_CODE && that.api.ERROR_CODE[code]) {
              returnMsg = that.api.ERROR_CODE[code];
            } else {
              returnMsg = msg;
            }
            Message({
              message: returnMsg,
              type: "error"
            });
            return Promise.reject(data.stat.stateList[0]);
          }
        }
      },
      error => {
        // 对响应错误做点什么
        return Promise.reject(error);
      }
    );
  }

  // 校验参数
  validate(options) {
    if (options) {
      if (!options.METHOD_NAME) {
        Message.error({
          message: "系统错误",
          type: "error"
        });
        return false;
      }
      return true;
    }
  }

  // 处理参数
  buildRequestData(options) {
    // 添加_mt参数
    const requestData = Object.assign(
      {},
      {
        _mt: options.METHOD_NAME
      }
    );

    // 添加选填参数
    for (let key in options.data) {
      let str = options.data[key];
      if (
        str != null &&
        Object.prototype.toString.call(str) !== "[object String]"
      ) {
        str = JSON.stringify(str);
      }
      requestData[key] = str;
    }

    return requestData;
  }

  // 创建实例
  create() {
    // const url = CONST_VD_API_REQUEST_URL;
    // let conf = {
    //   baseURL: url
    // };
    return axios.create();
  }

  // 请求实例
  request(options) {
    var instance = this.create();
    this.interceptors(instance, options.url, options);
    options = Object.assign({}, options);
    this.queue[options.url] = instance;
    return instance(options);
  }

  // 发送请求
  sendRequest(options) {
    this.api = options;

    // 重置参数
    this.options.url = this.api.url ? this.api.url : this.options.url;
    this.options.method = this.api.method
      ? this.api.method
      : this.options.method;

    // 进行数据校验
    var checkResult = this.validate(options);

    if (checkResult !== true) {
      return;
    }
    // 构建请求数据
    const requestData = this.buildRequestData(options);

    // 构建请求参数
    const requestOptions = Object.assign(this.options, {
      transformRequest:
        this.options.method == "POST" ? this.transformRequest() : [],
      data: this.sign(requestData),
      params: this.api.params
    });

    // 发送请求
    return this.request(requestOptions);
  }

  sign(params, isForceUserLogin) {
    var map = {
      None: function(data) {
        return Object.assign(data, {
          _sig: this.encrypt(data, CONST_NONE_APPEND_WORD)
        });
      },

      RegisteredDevice: function(data) {
        return Object.assign(data, {
          _sig: this.encrypt(data, CONST_NONE_APPEND_WORD)
        });
      },

      UserLogin: function(data) {
        var token = getToken();
        if (token) {
          return Object.assign(data, {
            _sig: this.encrypt(data, token)
          });
        } else {
          // 如果token不存在，则返回登录页
          toLoginPage();
        }
      }
    };
    if (typeof map[this.api.SECURITY_TYPE] === "function") {
      // 过滤所有的undefined和null的数据
      for (const key in params) {
        if (!params[key]) {
          delete params[key];
        }
      }

      // 将参数附加上必须要传递的标记
      const required = Object.assign(params, CONST_DEFAULT_REQUEST_HEADER, {
        _aid: this.aid
      });

      // 做加密生产_sig对象
      const _sig = map[this.api.SECURITY_TYPE].call(
        this,
        required,
        isForceUserLogin
      );

      // 返回数据可以直接做请求
      return Object.assign(required, _sig);
    } else {
      return params;
    }
  }

  encrypt(params, appendWord) {
    var arr = [];

    // 将Map变成Array，使用key=value的方式进行拼接
    for (const key in params) {
      if (params.hasOwnProperty(key) && key != "_sig") {
        arr.push(key + "=" + params[key]);
      }
    }

    arr.sort();
    // 将队列拼接成String
    var str = arr.join("");
    str = str + appendWord;

    return md5(str);
  }

  transformRequest() {
    return [
      function(data) {
        let ret = "";
        for (let it in data) {
          let str = data[it];
          ret += it + "=" + encodeURIComponent(str) + "&";
        }
        return ret;
      }
    ];
  }

  // 判断请求是否成功
  access(res) {
    if (
      res.stat.code === 0 &&
      res.content[0] &&
      res.stat.stateList[0].code === 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  afterRequest(mt, response) {
    const map = {
      "user.webLogin": function(response) {
        setToken(response.csrfToken);
      },

      "user.partnerLogin": function(response) {
        setToken(response.csrfToken);
      },

      "user.mobileRegister": function(response) {
        setToken(response.csrfToken);
      }
    };

    if (typeof map[mt] == "function") {
      map[mt].call(this, response);
    }
  }
}

export default httpRequest;
